import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { ClientReturnFolder } from "@redotech/redo-model/views/folders";
import { ClientReturnView } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getReturnViewsAndFolders = {
  name: "getReturnViewsAndFolders" as const,
  input: z.object({ type: createEnum(ReturnTypeEnum) }),
  output: z.object({
    views: z.array(ClientReturnView),
    folders: z.array(ClientReturnFolder),
  }),
};
